import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class NameTooLongFail extends UploadFail {
    static WEB_BACKEND_ERROR = 'name_too_long';

    radarName = 'fail_{SOURCE}_name-too-long';
    message = [
        'Превышена длина имени.',
        '<a href="https://help.mail.ru/cloud_web/confines" rel="noopener" target="_blank">Подробнее</a>',
    ].join(' ');
}
